// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { getScratchAndDentParent, getScratchAndDentSellPrice } from '@plumberssupply/App/Store/Selectors/ScratchAndDentSelectors';
import { color, mergeWithCss } from "@plumberssupply/XDL/Utilities";
import React, { FC, useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: ProductModel;
    text?: string;
    extendedStyles?: TypographyPresentationProps;
}

const productPreviousPurchaseStyles: TypographyPresentationProps = {
    size: 9,
    weight: "bold",
    color: "success",
    css: css`
        letter-spacing: 0;
        line-height: 11px;
        background-color: ${color("success.light")};
        border: 1px solid ${color("success")};
        padding: 3px 7px;
        text-align: center;
    `,
};

const ProductPreviousPurchase: FC<OwnProps> = ({ product, text, extendedStyles }) => {
    const [styles] = useState(() => mergeWithCss(productPreviousPurchaseStyles, extendedStyles));

    if (((product.properties.plumbers_isPreviouslyPurchased || "").toLowerCase() === "false") || getScratchAndDentSellPrice(product.properties)) {
        return null;
    }

    return (
        <Typography {...styles} data-test-selector="ProductPreviousPurchase">
            { text || translate("Prev. Purchase")}
        </Typography>
    );
};

export default ProductPreviousPurchase;
